import React from 'react';
import { CouponValueTypeEnum } from '../../../../api/payments/coupons/domain/enum';

function formatToCurrency(value) {
  return Number(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

export function DiscountPricePreview({ plan, valueType, value, hideLabel }) {
  if (!plan || value === '' || value === null || value === undefined) {
    return null;
  }

  const originalPrice = Number(plan?.price ?? plan?.amount ?? plan?.value);
  const discountValue = Number(value);

  if (!Number.isFinite(originalPrice) || !Number.isFinite(discountValue)) {
    return null;
  }

  const rawPrice =
    valueType === CouponValueTypeEnum.PERCENT
      ? originalPrice * (1 - discountValue / 100)
      : originalPrice - discountValue;
  const finalPrice = Math.max(0, rawPrice);

  return (
    <div
      className="d-flex align-items-center"
      style={{ gap: 'var(--space-8)', marginTop: 'var(--space-8)', flexWrap: 'wrap' }}
    >
      <span
        className="text-muted"
        style={{ textDecoration: 'line-through' }}
      >
        {formatToCurrency(originalPrice)}
      </span>
      <span className="jds-title-sm" style={{ color: 'var(--fg-brand-strong)' }}>
        {formatToCurrency(finalPrice)}
      </span>
      {!hideLabel && (
        <span className="text-muted">
          preço de "{plan.name}" com o desconto aplicado
        </span>
      )}
    </div>
  );
}
